// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { mountainSun16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-mountain-sun': IconMountainSun;
    }
}

/**
 * The icon component for the 'mountainSun' icon
 */
export class IconMountainSun extends IconSvg {
    public constructor() {
        super(mountainSun16X16);
    }
}

registerIconSvg('icon-mountain-sun', IconMountainSun);
export const iconMountainSunTag = 'nimble-icon-mountain-sun';
